var exports = {
  "uW": "VoiceActivitySection.module__section___TXhSYk",
  "eV": "VoiceActivitySection.module__moreCallsText___TXhSYk",
  "ti": "VoiceActivitySection.module__allCallsGrid___TXhSYk",
  "ux": "VoiceActivitySection.module__gridItem___TXhSYk",
};

module.exports = exports;
